<template>
  <div class="col-lg-6 left-content" :class="!showCampaignImage ? 'left-content-bcolor' : ''" v-if="!isWebView">
    <div class="desktop-content-wrapper">
      <div
        class="left-content-wrapper"
        :style="[isHaveChannelImage ? { 'background-image': 'url(' + partnerURL + ')' } : {}]"
        :class="{ 'content-partner-background': isHaveChannelImage }"
        v-if="isHaveChannelImage && !showCampaignImage"
      ></div>
      <div
        class="left-content-wrapper"
        :class="
          showCampaignImage
            ? 'nineteen-may-campaign-img-field ' +
              (isWebsiteMukellef ? 'campaign-image-mukellef' : 'campaign-image-workhy')
            : 'no-campaign'
        "
      >
        <template v-if="showCampaignImage">
          <div>
            <img
              :src="isWebsiteMukellef ? '/img/logo/mukellef_logo_white_updated.svg' : '/img/logo/workhy_logo_white.svg'"
              class="logo-item"
              alt=""
            />

            <p class="campaign-text">{{ $t('blackFridaySale') }}</p>
          </div>
        </template>
        <template v-else-if="isConnect && this.$i18n.locale === 'tr'">
          <div class="connect-field">
            <div class="connect-top-field">
              <img src="/img/logo/workhy_connect_logo.svg" class="logo-item-connect" alt="" />

              <p class="connect-text">Yurt dışındaki hizmetlerimizden Workhy markamız ile yararlanabilirsiniz.</p>
            </div>
            <div class="logo-field-connect" v-if="!showCampaignImage">
              <img src="/img/workhy-connect-world.png" />
            </div>
          </div>
        </template>
        <template v-else>
          <div>
            <img
              :src="isWebsiteMukellef ? '/img/logo/mukellef_logo_white_updated.svg' : '/img/logo/workhy_logo_white.svg'"
              class="logo-item"
              alt=""
            />

            <p v-if="showCampaignImage" class="campaign-text">{{ $t('blackFridaySale') }}</p>
          </div>

          <div class="logo-field" v-if="!showCampaignImage">
            <img src="/img/transparent-workhy-logo.svg" />
          </div>
        </template>
      </div>

      <div v-if="isWebsiteMukellef && showCampaignImage" class="campaign-bottom-text">
        *Sadece yeni satın alımlar için peşin ödemelerde geçerlidir.
      </div>
    </div>

    <div class="mobile-content-wrapper">
      <div class="mobile-content-wrapper-inside">
        <div class="left-content-wrapper" v-if="!showCampaignImage">
          <div>
            <img
              :src="isWebsiteMukellef ? '/img/logo/mukellef_logo_white_updated.svg' : '/img/logo/workhy_logo_white.svg'"
              class="logo-item"
              alt=""
            />
          </div>

          <div class="logo-field">
            <img src="/img/transparent-workhy-logo.svg" />
          </div>
        </div>
        <div v-else>
          <img
            :src="
              isWebsiteMukellef
                ? '/img/campaign-image-mukellef-mobil-new.svg'
                : '/img/campaign-image-workhy-mobil-new.svg'
            "
            class="w-100 relative"
            alt=""
          />
          <div v-if="isWebsiteMukellef" class="mobile-campaingn-text-field">
            *Sadece yeni satın alımlar için peşin ödemelerde geçerlidir.
          </div>
          <div class="mobile-logo">
            <img
              :src="isWebsiteMukellef ? '/img/logo/mukellef_logo_white_updated.svg' : '/img/logo/workhy_logo_white.svg'"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <!-- /content-left-wrapper -->
  </div>
  <!-- /content-left -->
</template>
<script>
export default {
  props: {
    partner: {
      type: String,
      default: null,
    },
    channel: {
      type: Object,
      default: function () {
        return {};
      },
    },
    showCampaign: {
      type: Boolean,
      default: false,
    },
    isConnect: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showCampaignImage() {
      return this.isInCampaignPeriod && this.showCampaign;
    },
    isHaveChannelImage() {
      return this.channel && this.channel.bg_image;
    },
    partnerURL() {
      if (this.channel && this.channel.bg_image) {
        return this.channel.bg_image;
      } else {
        return 'https://s3-eu-west-1.amazonaws.com/mukellef-assets/partner/' + this.partner + '.png';
      }
    },
  },
};
</script>

<style lang="less">
.desktop-content-wrapper {
  display: block;
  height: 100%;
  min-height: 100%;
}
.mobile-content-wrapper {
  display: none;
}

.left-content {
  padding: 0;
}
.left-content-bcolor {
  background-color: #191335;
}
.left-content-wrapper {
  display: flex;
  justify-content: center;
  text-align: center;
  height: 100%;
  min-height: 100%;
  padding: 20px 20px 20px 20px;

  color: #fff;
  text-align: center;
  position: relative;
}

.logo-item {
  max-width: 100%;
  height: 70px;
  @media (max-width: 991px) {
    width: 180px !important;
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    height: 78px !important;
  }
}
.left-content-wrapper:not(.nineteen-may-campaign-img-field) {
  align-items: center;
  background: radial-gradient(
        62.17% 55.02% at 50% 100.98%,
        rgba(125, 82, 158, 0.5) 0%,
        rgba(125, 82, 158, 0.2) 50%,
        rgba(85, 63, 185, 0) 100%,
        rgba(0, 0, 0, 0) 100%
      )
      /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */,
    #191335;

  .logo-item {
    margin-bottom: 250px;
  }
}
@media (max-width: 991px) {
  .left-content-wrapper {
    height: auto;
    padding: 10px 30px 10px 30px;
    justify-content: space-between;
  }
  .mobile-content-wrapper {
    display: block;
  }
  .desktop-content-wrapper {
    display: none;
  }
}

.left-content-wrapper .logo-field img {
  width: 50%;
  max-width: 700px;
}
@media (max-width: 991px) {
  .left-content-wrapper .logo-field img {
    width: 100px;
  }
}

.logo-field {
  position: absolute;
  bottom: 60px;
  left: 0;
  width: 100%;
  opacity: 0.5;
}
@media (max-width: 991px) {
  .logo-field {
    width: auto !important;
    height: 100%;
    position: initial;
    left: initial !important;
    right: 0px !important;
    bottom: 0;
    width: 150px;
    text-align: right;
  }
}
@media (max-width: 354px) {
  .logo-field {
    display: none;
  }
}

.connect-field {
  .logo-field-connect {
    bottom: 120px;
    left: 0;
    width: 100%;
  }
  .logo-field-connect img {
    max-width: 400px;
  }
  .logo-item-connect {
    margin-bottom: 50px;
  }

  .connect-text {
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    margin: 0px 30px 0px 30px;
    margin-bottom: 40px;
    max-width: 500px;
  }
}

.nineteen-may-campaign-img-field {
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: top center !important;
  min-height: 300px !important;
  align-items: start;

  .logo-item {
    margin-top: 148px;
  }

  .campaign-text {
    font-size: 64px;
    font-weight: 700;
    line-height: 70px;
    letter-spacing: -3.247px;
    margin-top: 28px;
  }

  &.campaign-image-mukellef {
    background-image: url('/img/campaign-image-mukellef-new.jpg');
  }
  &.campaign-image-workhy {
    background-image: url('/img/campaign-image-workhy-new.jpg');
  }
}
.campaign-bottom-text {
  position: absolute;
  bottom: 40px;
  width: 100%;
  margin: 0px auto;
  text-align: center;
  color: white;
  font-weight: bold;
}
.left-content-wrapper-campaign-mobile {
  background-image: url('/img/campaign-image-mukellef-mobil.svg');
}
.mobile-logo {
  position: absolute;
  left: 16px;
  top: 0px;
  bottom: 0px;
  margin-top: 24px;
  width: 172px;
}

.mobile-campaingn-text-field {
  position: absolute;
  left: 16px;
  bottom: 12px;
  color: white;
  font-size: 10px;
  text-align: right;
  font-weight: 500;
}
</style>
